import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors, NonNullableFormBuilder } from "@angular/forms";
import { Constants } from "../helpers/constants";

export class M_STORE_BOARD {
    agreE_CD: string = '';
    agreE_NM: string = '';
    boarD_CONTENTS: string = '';
    boarD_SEQ: number = 0;
    boarD_TITLE: string = '';
    boarD_TP: string = '';
    boarD_TP_NM: string = '';
    cmT_CNT: number = 0;
    depT_NM: string = '';
    enD_DT: string = '';
    hQ_CD: string = '';
    inserT_DT: string = '';
    inserT_USER: string = '';
    noticE_YN: string = '';
    remark: string = '';
    stR_CD: string = '';
    starT_DT: string = '';
    updatE_DT: string = '';
    updatE_USER: string = '';
    usE_YN: string = '';
    vieW_CNT: number = 0;
    writeR_ID: string = '';
    files : any = [];

    constructor(init?: Partial<M_STORE_BOARD>) {
        Object.assign(this, init);
    }

    toJSON(): any {
        const obj: any = {};

        Object.keys(this).forEach(key => {
            const value = (this as any)[key];
            if (
                (key === 'starT_DT' || key === 'enD_DT') &&
                value
            ) {
                obj[key] = this.formatDate(value);
            } else {
                obj[key] = value ?? null;
            }
        });

        return obj;
    }

    fromJSON(json: any): M_STORE_BOARD {
        return new M_STORE_BOARD(json);
    }

    getAll(res: any[]): M_STORE_BOARD[] {
        return (res ?? []).map(e => {
            if (e?.inserT_DT) {
                e.inserT_DT = this.formatStringDateYYYMMDDHHMMSS(e.inserT_DT);
            }

            if (e?.starT_DT) {
                e.starT_DT = this.formatStringDateYYYMMDD(e.starT_DT);
            }

            if (e?.enD_DT) {
                e.enD_DT = this.formatStringDateYYYMMDD(e.enD_DT);
            }

            return new M_STORE_BOARD(e);
        });
    }

    createForm(fb: FormBuilder): FormGroup {
        return fb.group(
            {
                hQ_CD: [''],
                stR_CD: [{ value: '', disabled: true }],
                agreE_CD: [''],
                agreE_NM: [''],

                boarD_CONTENTS: ['', [Validators.required]],
                boarD_SEQ: [{ value: 0, disabled: true }],
                boarD_TITLE: ['', [Validators.required]],
                boarD_TP: [''],
                boarD_TP_NM: [''],

                cmT_CNT: [0],
                depT_NM: [''],
                enD_DT: [''],

                inserT_DT: [{value: '', disabled : true}],
                inserT_USER: [''],
                noticE_YN: [''],
                remark: [''],

                starT_DT: [''],
                updatE_DT: [''],
                updatE_USER: [''],

                usE_YN: [''],
                vieW_CNT: [0],
                writeR_ID: [''],
            });
    }

    formatDate(dateString: string): string {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0')

        return `${year}${month}${day}`;

    }

    parseYYYYMMDD(value: string | number): Date | null {
        if (!value) return null;

        const str = value.toString();
        if (str.length !== 8) return null;

        const year = Number(str.substring(0, 4));
        const month = Number(str.substring(4, 6)) - 1;
        const day = Number(str.substring(6, 8));

        return new Date(year, month, day);
    }

    formatStringDateYYYMMDDHHMMSS(dateString: any): string {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            throw new Error("Invalid date string");
        }

        date.setHours(date.getHours() + 9);

        const pad = (num: number) => String(num).padStart(2, '0');

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());


        const ret = `${year}-${month}-${day}`
        return ret;
    }

    formatStringDateYYYMMDD(dateString: any): string | null {
        const date = this.parseYYYYMMDD(dateString) as Date | null;
        if (!date) return null;

        if (isNaN(date.getTime())) {
            throw new Error("Invalid date string");
        }

        const pad = (num: number) => String(num).padStart(2, '0');

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());

        const ret =  `${year}-${month}-${day}`
        return ret;
    }
}
